import { render } from "./MobileServiceList.vue?vue&type=template&id=cdf73eda&scoped=true"
import script from "./MobileServiceList.vue?vue&type=script&lang=js"
export * from "./MobileServiceList.vue?vue&type=script&lang=js"

import "./MobileServiceList.vue?vue&type=style&index=0&id=cdf73eda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdf73eda"]])

export default __exports__